<!--布局主文件-->
<template>
  <Layout style="height: 100%" class="main">

    <!--左侧侧边栏 start-->
    <Sider hide-trigger collapsible :width="180" :collapsed-width="64" v-model="collapsed" class="left-sider"
      :style="{ overflow: 'hidden' }">
      <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" theme="dark" width="auto"
        @on-select="turnToPage" :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <img v-show="!collapsed" src="@/assets/images/logo.jpg" key="max-logo" />
          <img v-show="collapsed" src="@/assets/images/logo-min.jpg" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <!--左侧侧边栏 end-->

    <Layout>
      <!--头部 start-->
      <Header class="header-con">
        <!--侧边栏伸缩按钮 start-->
        <a @click="collapsed = !collapsed" type="text" :class="['sider-trigger-a', collapsed ? 'collapsed' : '']">
          <Icon type="md-menu" size="24" />
        </a>
        <!--侧边栏伸缩按钮 end-->

        <!--路由导航显示 start-->
        <div class="custom-bread-crumb">
          <Breadcrumb style="font-size: 14px">
            <BreadcrumbItem v-for="(item, key) in headerBreadCrumb" :to="item.to || ''" :key="`bread-crumb-${key}`">
              <commonIcon :type="item.icon || ''"></commonIcon> {{ item.title }}
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
        <!--路由导航显示 end-->

        <!-- 关联账号切换（如果有则显示），放在 header-tool-con 之前，与其平行 -->
        <div v-if="multiAccounts && multiAccounts.length" class="account-switch-con" style="float: right; margin-right: 120px; line-height:64px;">
          <Dropdown @on-click="dropDownClick">
            <span style="cursor:pointer;">{{ user_name }}</span>
            <Icon :size="18" type="md-arrow-dropdown"></Icon>
            <DropdownMenu slot="list">
              <DropdownItem v-for="(acc, idx) in multiAccounts" :key="`switch-${idx}`" :name="`switch-${idx}`">
                切换账号：{{ acc.name || acc.username || acc.mobile }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>



        <!--右侧工具栏 start-->
        <div class="header-tool-con">

          <!-- 头像下拉：仅保留 修改密码 / 退出 登录项 -->
          <div class="user-avatar-dropdown">
            <Dropdown @on-click="dropDownClick">
              <Icon :size="22" type="ios-person"></Icon>
              <DropdownMenu slot="list">
                <DropdownItem name="resetPwd">修改密码</DropdownItem>
                <DropdownItem name="logout">退出登录</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>

          <div class="full-screen-btn-con" style="margin-right: 10px;">
            <Tooltip :content="isFullScreen ? '退出全屏' : '全屏'" placement="bottom">
              <Icon @click.native="handleFullscreen" :type="isFullScreen ? 'md-contract' : 'md-expand'" :size="23">
              </Icon>
            </Tooltip>
          </div>
          <!--手册与关注公众号 -->
          <div class="am_follow" v-if="authRoute">
            <div class="am_manual" @click="getManual()"><span>操作手册</span></div>
            <div class="am_wx" @mousemove="showTooltip()" @mouseleave="hideTooltip()">
              <span>关注微信号</span>
              <div class="am_wananchi" v-if="showWx"><img src="../../assets/images/wx.png"></div>

            </div>

          </div>
        </div>
        <!--右侧工具栏 end-->

      </Header>
      <!--头部 end-->

      <!--正文 start-->
      <Content class="main-content-con">
        <Layout class="main-layout-con">

          <!--已打开页面标签栏 start-->
          <div class="tag-nav-wrapper" v-if="!is_single_page">
            <tags-nav :list="openedPage" />
          </div>
          <!--已打开页面标签栏 end-->

          <Content class="content-wrapper">
            <Card class="content-card">
              <keep-alive><router-view /></keep-alive>
            </Card>
          </Content>

        </Layout>
      </Content>
      <!--正文 end-->

      <Drawer title="密码修改" v-model="isResetPwd" width="500">
        <Form :lable-width="100">
          <FormItem label="原密码：" prop="oldPwd">
            <Input v-model="resetPwdData.oldPwd"></Input>
          </FormItem>
          <FormItem label="新密码：" prop="newPwd">
            <Input v-model="resetPwdData.newPwd"></Input>
          </FormItem>
          <FormItem label="确认密码：" prop="newPwd2">
            <Input v-model="resetPwdData.newPwd2"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="resetPwd">提交</Button>
          </FormItem>
        </Form>
      </Drawer>

    </Layout>

  </Layout>
</template>

<script>
import layoutMixin from './layout-mixin'
import SideMenu from './side-menu'
import TagsNav from './tags-nav'
import commonIcon from '@/components/common-icon'
import { getMenuLists, loginOut, setToken, dealAuthRoute } from "@/lib/util";
import { doSwitchAccount } from '@/api/login'
import baseConfig from '@/config/base-config'



export default {
  name: "layout",
  components: { TagsNav, commonIcon, SideMenu },
  mixins: [layoutMixin],
  data() {
    return {
      collapsed: false,
      accordion: true,       //菜单开启手风琴模式
      theme: 'dark',
      isFullScreen: false,
      menuList: [],
      openedMenu: [],        //当前目录
      is_single_page: baseConfig.IS_SINGLE_PAGE,
      user_name: sessionStorage.getItem('user_name'),

      isResetPwd: false,
      resetPwdData: {
        oldPwd: '',
        newPwd: '',
        newPwd2: '',
      },
      showWx: false,
      authRoute: false,

      multiAccounts: [], // 当前登录用户可切换的账号列表（从 sessionStorage 读取）
    }
  },
  methods: {
    // 切换账号主逻辑
    async switchAccountTo(index) {
      const accounts = this.multiAccounts || []
      const acc = accounts[index]
      if (!acc) return
      this.$Modal.confirm({
        title: '切换账号',
        content: `确认切换到账号：${acc.name || acc.username || acc.mobile} ?`,
        loading: true,
        onOk: async () => {
          try {
            // 调用后端切换接口，后端会清理旧缓存并为目标账号写入新的 token / 缓存
            const res = await doSwitchAccount(acc.uid)
            // 成功后保存后端返回的数据到 sessionStorage
            const data = res.data || {}
            sessionStorage.setItem('user_name', (data.user_info && data.user_info.name) || acc.name || acc.username || '')
            sessionStorage.setItem('groupID', ((data.user_info && data.user_info.group_id) || acc.group_id || '') + '')
            sessionStorage.setItem('userInfo', JSON.stringify(data.user_info || acc))
            const multi = data.multiAccounts || acc.multiAccounts || acc.multi_accounts || this.multiAccounts || []
            sessionStorage.setItem('multiAccounts', JSON.stringify(multi))

            // 更新 token 并重建权限路由
            if (data.token) {
              setToken(data.token)
            }
            dealAuthRoute(undefined, { routerInstance: this.$router, storeInstance: this.$store })

            // 刷新页面（不会跳回登录页）
            window.location.reload()
          } catch (err) {
            this.$commonFun.errorTip('切换账号失败')
          }
        }
      })
    },
    getManual() {
      // this.$commonFun.jumpTo(routes[4].path)
      this.$commonFun.jumpTo('/document')

    },
    showTooltip() {

      this.showWx = true

    },
    getAuth() {
      var groupID = parseInt(sessionStorage.getItem('groupID'))
      if (groupID == 4) {
        this.authRoute = true
      }

    },
    hideTooltip() {
      this.showWx = false
    },
    //菜单栏点击跳转
    turnToPage(name) {
      this.$commonFun.jumpTo('', name)
    },
    //头像点击事件
    dropDownClick(name) {
      if (!name) return
      if (name.startsWith && name.startsWith('switch-')) {
        const idx = parseInt(name.split('-')[1], 10)
        if (!isNaN(idx)) {
          return this.switchAccountTo(idx)
        }
      }
      if (name === 'logout') {
        loginOut()
        this.$nextTick(() => {
          this.$commonFun.jumpTo('/login')
        })
      } else if (name === 'resetPwd') {
        this.isResetPwd = true;
      } else {
        return false
      }
    },
    getOpenedMenu(name) {
      if (name === this.$config.HOME_PAGE) {
        this.openedMenu = []
      } else {
        this.openedMenu = this.$route.matched.map(item => item.name).filter(item => item !== name)
      }
    },
    handleFullscreen() {
      let main = document.body
      if (this.isFullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen()
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen()
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen()
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen()
        }
      }
    },

    async resetPwd() {
      let res = await this.$commonFun.postProxy('admin/system/admin_user/resetMyPwd', this.resetPwdData);
      this.$commonFun.dealApiResult(res, (res) => {
        this.$commonFun.successTip(res.msg, () => {
          this.isResetPwd = false
          loginOut()
          this.$commonFun.jumpTo('/login')
        })
      })
    },
  },
  computed: {
    openedPage() {
      return this.$store.state.app.openedPage
    },
    headerBreadCrumb() {
      return this.$store.state.app.headerBreadCrumb
    }
  },
  mounted() {
    //初始化左侧菜单列表
    this.menuList = getMenuLists();
    // 读取 multiAccounts 到组件状态，供下拉菜单显示
    try {
      const ma = sessionStorage.getItem('multiAccounts') || '[]'
      this.multiAccounts = JSON.parse(ma)
    } catch (e) {
      this.multiAccounts = []
    }

    this.$store.commit('app/setBreadCrumb', this.$route)               //初始化顶部面包屑


    //js的神坑，不能直接传值this.$route,会造成引用关系报错
    const { name, params, query, meta } = this.$route
    this.$store.dispatch('app/changeOpenedPage', { route: { name, params, query, meta } })      //初始化标签栏


    this.getAuth()//初始化手册关注公众号


  },
  watch: {
    //监听路由变化 ，设置顶部面包屑 和 打开的页面列表
    '$route'(newRoute) {
      this.$store.commit('app/setBreadCrumb', newRoute)

      const { name, query, params, meta } = newRoute
      this.$store.dispatch('app/changeOpenedPage', { route: { name, query, params, meta } })
      this.getOpenedMenu(newRoute.name)
    },
    openedMenu() {
      this.$nextTick(() => {
        this.$refs.sideMenu.updateOpenName()
      })
    }
  },
}
</script>

<style scoped lang="less">
.main {

  /*logo样式*/
  .logo-con {
    height: 64px;
    padding: 10px;

    img {
      height: 44px;
      width: auto;
      display: block;
      margin: 0 auto;
    }
  }

  /*头部内容样式 start*/
  .header-con {
    background: #fff;
    padding: 0 20px;
    width: 100%;
    position: relative;

    /*伸缩侧边栏点击按钮样式*/
    .trans {
      transition: transform .2s ease;
    }

    @size: 40px;

    .sider-trigger-a {
      padding: 6px;
      width: @size;
      height: @size;
      display: inline-block;
      text-align: center;
      color: #5c6b77;
      margin-top: 12px;

      i {
        .trans;
        vertical-align: top;
      }

      &.collapsed i {
        transform: rotateZ(90deg);
        .trans;
      }
    }

    /*顶部当前路径面包屑样式*/
    .custom-bread-crumb {
      display: inline-block;
      vertical-align: top;
      margin-left: 30px;
    }

    /*顶部右侧工具栏样式*/
    .header-tool-con {
      float: right;
      height: auto;
      padding-right: 20px;
      line-height: 64px;

      &>* {
        float: right;
      }

      .user {
        &-avatar-dropdown {
          cursor: pointer;
          display: inline-block;
          // height: 64px;
          vertical-align: middle;

          // line-height: 64px;
          .ivu-badge-dot {
            top: 16px;
          }
        }
      }

      /*头像下拉样式*/
      .user-avatar-dropdown {
        cursor: pointer;
        display: inline-block;
        vertical-align: middle;

        /deep/ .ivu-badge-dot {
          top: 16px;
        }
      }
    }


  }

  /*头部内容样式 end*/

  .main-content-con {

    /*height: ~"calc(100% - 60px)";*/
    /*overflow: hidden;*/
    .main-layout-con {
      height: 100%;
      overflow: hidden;

      .tag-nav-wrapper {
        padding: 0;
        height: 40px;
        background: #F0F0F0;
      }
    }

    .content-wrapper {
      padding: 10px;
      height: ~"calc(100% - 80px)";
      overflow: auto;

      .content-card {
        height: 100%;
      }
    }
  }

  .left-sider {
    /deep/ .ivu-layout-sider-children {
      overflow-y: scroll;
      margin-right: -18px;
    }

    &.ivu-layout-sider {
      background-color: #001529 !important;
    }

    /deep/ .ivu-menu-dark {
      background-color: #001529 !important;
    }

    /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
      background-color: #001529 !important;
    }
  }
}

  .am_follow {
    display: inline-block;
    vertical-align: top;
    margin-right: 30px;
    float: right;
  }

  .am_manual {
    cursor: pointer;
    float: left;
    margin-right: 10px;
  }

  .am_manual span {
    font-size: 15px;
  }

  .am_wx {
    cursor: pointer;
    float: right;
    margin-left: 10px;
    position: relative;
  }

  .am_wx span {
    font-size: 15px;
  }

  .am_wananchi {
    position: absolute;
    right: 130px;
    z-index: 999;
    margin-top: 8px;
  }

  .am_wananchi {
    width: 100%;
    height: 100%;
  }
</style>
